<template>
    <div class="confirm">
        <div>
            <button type="submit" class="back" @click="back()">
                Back
            </button>
        </div>
        <div>
            <save-button 
                v-if="showSaveProgress"
                class="alternate"
                v-on:clicked="saveProgress"
                :saving="saving"
                :default-text="saveProgressButtonText"
                >
            </save-button>

            <button v-if="!isLast" class="alternate" @click="save()">
                <span v-text="saveAndSummaryButtonText"></span>
            </button>

            <button type="submit" @click="next()">
                <span v-text="nextButtonText"></span>
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        nextButtonText: {
            default: 'Next'
        },
        saveAndSummaryButtonText: {
            default: 'Save & View Summary'
        },
        saveProgressButtonText: {
            default: 'Save Progress'
        },
        saving: {
            default: false
        },
        saveButtonFinishedText: {
            default: 'Saved!'
        },
    },
    data() {
        return {
            designId: null,
            route: null,
        };
    },
    methods: {
        back() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/submittal-manager');
        },
        next() {
           this.$emit('next');
        },
        save() {
            this.$emit('save');
        },
        saveProgress() {
            this.$emit('saveProgress');
        },
    },
    computed: {
        showSaveProgress() {
            return ['submittal-brace-piping', 'submittal-brace-attachment'].includes(this.route);
        },
        isLast() {
            return this.route == 'submittal-brace-attachment';
        }
    },
    mounted() {
        this.designId = this.$route.params.designId;
        this.route = this.$route.name;
    }
};
</script>